// extracted by mini-css-extract-plugin
export default {"logo":"Logo_logo__wZD4G","item":"Logo_item__E7u--","light":"Logo_light__V5C7t","dark":"Logo_dark__mfhsc"};